const passwordConditionsTemplate = {
    MinChar: { valid: false, description: "minimum 8 znaków" },
    BigLetter: { valid: false, description: "przynajmniej jedna duża litera" },
    SmallLetter: { valid: false, description: "przynajmniej jedna mała litera" },
    Digit: { valid: false, description: "przynajmniej jedna cyfra" },
    SpecialChar: { valid: false, description: "przynajmniej jeden znak specjalny" },
}

export const checkIfPasswordMeetsConditions = (password) => {
    const currentResults = JSON.parse(JSON.stringify(passwordConditionsTemplate))
    if (password.length >= 8) {
        currentResults.MinChar.valid = true;
    }
    if (/[A-Z]/.test(password)) {
        currentResults.BigLetter.valid = true;
    }
    if (/[a-z]/.test(password)) {
        currentResults.SmallLetter.valid = true;
    }
    if (/[0-9]/.test(password)) {
        currentResults.Digit.valid = true;
    }
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        currentResults.SpecialChar.valid = true;
    }
    return currentResults;
}

export const passwordConditionText = `Hasło musi zawierać: ${passwordConditionsTemplate.MinChar.description}, ${passwordConditionsTemplate.BigLetter.description}, 
${passwordConditionsTemplate.SmallLetter.description}, ${passwordConditionsTemplate.Digit.description}, 
${passwordConditionsTemplate.SpecialChar.description}`